<template>
  <div class="docs common-main">
    <!-- 搜索 -->
    <SearchForm
      @search="onSearch"
      :categoryList="categoryList"
      @getCategoryValue="getCategoryValue"
      @change="onChange"
      :loading="loading"
    />

    <div class="docs-list" v-if="loading">
      <Loading :show="true" :text="$t('docs_search_loading_text')" />
    </div>
    <div class="docs-list" v-else>
      <div class="docs-list-title">
        <p>
          <i v-if="list && list.length > 0">
            {{ $t('docs_search_result1') }}<span>{{ pagination.total }}</span
            >{{ $t('docs_search_result2') }}：
          </i>
        </p>
        <p>
          <a-button type="primary" @click="$router.go(-1)">
            {{ $t('docs_return_list') }}
          </a-button>
        </p>
      </div>
      <div class="docs-list-content" v-if="list && list.length > 0">
        <div class="docs-list-item" v-for="item in list" :key="item.id">
          <div class="docs-list-item-desc">
            <!-- 详情链接，如果有权限查看文档详情 -->
            <router-link
              :to="{
                name: 'DocsDetail',
                params: { id: item.id },
              }"
              v-if="AUTH_DOCS_DETAIL"
            >
              <!-- 标题部分 -->
              <div class="docs-list-item-title">
                <span
                  v-for="(part, index) in highlightKeyword(item.title)"
                  :key="index"
                  :class="part.isKeyword ? 'highlight' : ''"
                  >{{ part.text }}</span
                >
              </div>
            </router-link>
            <div v-else>
              <!-- 标题部分 -->
              <div class="docs-list-item-title">
                <span
                  v-for="(part, index) in highlightKeyword(item.title)"
                  :key="index"
                  :class="part.isKeyword ? 'highlight' : ''"
                  >{{ part.text }}</span
                >
              </div>
            </div>

            <!-- 高亮显示内容中的关键字 -->
            <div class="content-wrapper">
              <span
                v-for="(part, index) in highlightKeyword(item.content)"
                :key="index"
                :class="part.isKeyword ? 'highlight' : ''"
                >{{ part.text }}</span
              >
            </div>

            <i>{{ $t('docs_search_lz') }}：{{ filterCategory(item.wikiCategoryId) }} </i>
          </div>
        </div>
        <div class="pagination" style="width:100%;">
          <Pagination
            :current.sync="pagination.current"
            :total="pagination.total"
            :pageSize.sync="pagination.pageSize"
            :callback="pageChange"
            @change="pageChange"
            sho-quick-jumper
          />
        </div>
      </div>
      <!-- 如果没有搜索结果，则显示空状态组件 -->
      <div class="docs-list-content" v-else>
        <Empty />
      </div>
    </div>
  </div>
</template>
<script>
import * as DocsAPI from '@/api/docs';
import SearchForm from './components/SearchForm';
import docsAuth from '@/views/docs/mixins/docsAuth';
import { trim } from '@/libs/utils';

export default {
  mixins: [docsAuth],
  components: {
    SearchForm,
  },
  name: 'Docs',
  data() {
    return {
      searchValue: '',
      finallySearchValue: '',
      // 所有分类
      categoryList: null,
      categoryValue: [],

      list: null,

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },
      loading: false,
    };
  },
  created() {
    this.getAllDocuments();

    // 如果URL中有带关键字过来，就搜索
    const { keyword, category } = this.$route.query;
    this.searchValue = keyword || '';
    this.categoryValue = category ? category.split(',').map(item => Number(item)) : [];

    this.onSearch();
  },
  methods: {
    // 获取所有分类
    getAllDocuments() {
      return DocsAPI.getAllCategories()
        .then(res => {
          if (res.code === 0 && res.data) {
            const _categoryList = [];
            res.data.forEach(item => {
              item.value = item.id;
              item.label = item.name;
              _categoryList.push(item);
            });
            this.categoryList = _categoryList;
          }
        })
        .catch(() => {
          this.categoryList = null;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // 获取分类
    getCategoryValue(value) {
      this.categoryValue = value;
      this.onSearch();
    },

    onChange(e) {
      this.searchValue = e.target.value;
    },

    // 搜索列表
    onSearch(event, value) {
      console.log('e onSearch', event, value);

      const params = {
        keyword: trim(this.searchValue),
        wcIds: (this.categoryValue || []).join(',') || undefined,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };

      if (!params.keyword) {
        // this.$message.error('请输入搜索关键字');
        return;
      }

      this.finallySearchValue = this.searchValue;

      this.loading = true;
      DocsAPI.searchDocument(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            this.list = res.data;
            this.pagination.total = res.totalCount;
          }
        })
        .catch(() => {
          this.list = null;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
          this.loading = false;
        });
    },

    // 分页
    pageChange(value) {
      this.pagination.current = value;
      this.onSearch(this.searchValue);
    },

    // 高亮搜索关键字
    highlightKeyword(text) {
      if (!text) {
        return text;
      }
      if (!this.finallySearchValue) {
        // 没有关键词直接返回处理后的原文本
        return [{ text: text.replace(/<\/?[^>]+(>|$)/g, ''), isKeyword: false }];
      }

      const keywordRegex = new RegExp(this.finallySearchValue, 'gi'); // 匹配关键词，忽略大小写
      // 使用标点符号（。！？）和指定的 HTML 分段标签分割文本
      const paragraphs = text.split(/(?<=[。！？;；])|<p>|<\/p>|<br>|<h[1-6]>|<\/h[1-6]>/gi);

      // 找到第一个包含关键词的段落
      const startIndex = paragraphs.findIndex(paragraph => keywordRegex.test(paragraph));
      if (startIndex === -1) {
        // 如果没有找到包含关键词的段落，则返回去除标签后的文本
        return [{ text: text.replace(/<\/?[^>]+(>|$)/g, ''), isKeyword: false }];
      }

      // 提取从关键词段落开始的所有内容
      const targetParagraphs = paragraphs.slice(startIndex);

      // 高亮关键词
      const highlightedContent = [];
      targetParagraphs.forEach(paragraph => {
        // 去除 HTML 标签
        const cleanText = paragraph.replace(/<\/?[^>]+(>|$)/g, '');

        // 按关键词拆分
        const parts = cleanText.split(keywordRegex);
        parts.forEach((part, index) => {
          highlightedContent.push({
            text: part,
            isKeyword: false,
          });
          // 如果不是最后一部分，添加关键词高亮
          if (index < parts.length - 1) {
            highlightedContent.push({
              text: this.finallySearchValue,
              isKeyword: true,
            });
          }
        });
      });

      return highlightedContent;
    },
    //   const parts = text.split(regex); // 分割文本
    //   const newParts = [];
    //   parts.forEach(part => {
    //     const _part = {
    //       text: part,
    //       isKeyword: regex.test(part),
    //     };
    //     newParts.push(_part);
    //   });
    //   return newParts;
    // },

    // 筛选分类
    filterCategory(categoryId) {
      const _categoryValue = (this.categoryList || []).filter(item => categoryId === item.id);
      if (_categoryValue && _categoryValue.length > 0) {
        return _categoryValue[0].name;
      }
      return '--';
    },
  },
};
</script>
<style lang="less" scoped>
.docs {
  background: @g-layout-background;
  overflow-y: auto;
  border-radius: 12px;
  height: 100%;
  .docs-header {
    padding: 24px;
    border-radius: 12px;
    background: #fff;
    margin-bottom: 16px;
    h3 {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
    }
    .docs-header-desc {
      display: flex;
      margin-top: 16px;
      .docs-header-desc-left {
        display: flex;
        align-items: flex-start;
        padding-right: 16px;

        svg {
          font-size: 24px;
          color: @primary-color;
          margin-top: 4px;
        }
      }

      .docs-header-desc-right {
        margin-right: 16px;

        p {
          color: var(--colorText, rgba(0, 0, 0, 0.88));
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          margin: 0;
        }
      }
    }
  }

  .docs-list {
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: calc(100% - 70px - 78px);
    .docs-list-title {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p {
        margin: 0;
        i {
          font-style: normal;
        }
        span {
          color: #1838d9;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          padding: 0 5px;
        }
      }
    }

    .docs-list-content {
      display: flex;
      padding: 24px 0;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      flex: 1 0 0;
      align-self: stretch;

      .docs-list-item {
        padding: 16px 24px;
        gap: 24px;
        flex: 1 0 0;
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        background: #fff;
        width: 100%;

        a {
          font-style: normal;
          font-weight: 600;
          display: flex;
          span {
            color: rgba(0, 0, 0, 0.88);
            font-size: 18px;
            font-style: normal;
            font-weight: 600;

            &.highlight {
              color: #1838d9 !important;
              font-weight: bold !important;
            }
          }

          &:hover {
            span {
              color: #1838d9 !important;
              text-decoration: underline;
            }
          }
        }

        .docs-list-item-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            width: 46px;
            height: 46px;
            font-size: 24px;
            color: @primary-color;
          }
        }

        .docs-list-item-desc {
          display: flex;
          flex-direction: column;
          gap: 8px;
          align-items: flex-start;

          /* 标题样式，保持加粗黑体 */
          .docs-list-item-title {
            font-weight: 600; /* 加粗 */
            font-size: 18px; /* 保持标题字号 */
            color: #18181a; /* 保持标题颜色 */
            margin: 0;
          }

          /* 包裹整个内容的父级容器 */
          .content-wrapper {
            display: -webkit-box; /* 使用多行文本框 */
            -webkit-line-clamp: 2; /* 限制最多显示两行 */
            -webkit-box-orient: vertical; /* 设置排列方向为垂直 */
            overflow: hidden; /* 隐藏超出部分 */
            text-overflow: ellipsis; /* 超出部分使用省略号显示 */
            width: 100%; /* 确保内容区域占满宽度 */
            font-weight: normal; /* 确保内容不是加粗 */
            font-size: 16px; /* 内容部分字号 */
            color: #18181a; /* 内容部分颜色 */
          }

          ///* 保持 title 部分为黑体加粗 */
          //.title {
          //  font-weight: 600;   /* 加粗黑体 */
          //  color: #18181a;     /* 保持原来的颜色 */
          //  font-size: 18px;     /* 保持原来的字号 */
          //}

          .highlight {
            color: #1838d9 !important; /* 高亮关键字颜色 */
            font-weight: bold !important; /* 高亮关键字加粗 */
          }

          i {
            color: #a0a0a7;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>
